import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import Text from '~components/Text';

export const S = {
  StyledEmployeeBarChart: styled.div<{ isActiveUser: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    scroll-margin-top: 250px;
    ${({ isActiveUser }) =>
      isActiveUser &&
      css`
        margin-top: 20px;
      `};
  `,
  SignupNudgeWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    ${({ theme }) => theme.media.mobile} {
      width: 100%;
    }
  `,
  ChartContent: styled(motion.div)`
    width: 100%;

    ${({ theme }) => theme.media.pc} {
      width: 400px;
    }
  `,
  MessageWrapper: styled.div`
    position: absolute;
    top: 20%;
    left: 50%;
    width: fit-content;
    transform: translate3d(-50%, -50%, 0);
    padding: 16px 24px;
    background-color: #fff;
    border: 1px solid ${({ theme }) => theme.colors.gray400};
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `,
  Message: styled(Text)`
    white-space: nowrap;
    text-align: center;
  `,
  VideoWrapper: styled.div`
    position: relative;
    width: 400px;
    height: 240px;
    margin: 0 auto;

    ${({ theme }) => theme.media.mobile} {
      width: 100%;
      height: 0;
      padding-bottom: 80%;
    }
  `,
  Video: styled.video`
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  `,
};
